export const HIGH_SCORE_CONFETTI_EMIT_DELAY_MS = 1800;

const HIGH_SCORE_CONFETTI_PARTICLE_COUNT = 70;
const HIGH_SCORE_CONFETTI_START_RADIUS = 14;
const HIGH_SCORE_CONFETTI_CONE_ANGLE_DEGREES = 64.1;
const HIGH_SCORE_CONFETTI_COLORS = ['#ffca31', '#f5910f', '#f25c78', '#18b692', '#00a1db', '#ffffff'] as const;

export type HighScoreConfettiPiece = {
	color: (typeof HIGH_SCORE_CONFETTI_COLORS)[number];
	duration: number;
	endX: number;
	endY: number;
	peakX: number;
	peakY: number;
	rotation: number;
	size: number;
	startX: number;
	startY: number;
	stretch: number;
};

const createSeededRandom = (seed: number) => {
	let value = seed;

	return () => {
		value = (value * 1664525 + 1013904223) % 4294967296;

		return value / 4294967296;
	};
};

const createHighScoreConfettiPieces = (): HighScoreConfettiPiece[] => {
	const random = createSeededRandom(20260720);

	return Array.from({ length: HIGH_SCORE_CONFETTI_PARTICLE_COUNT }, (_, index) => {
		const angle = -90 + (random() - 0.5) * HIGH_SCORE_CONFETTI_CONE_ANGLE_DEGREES + Math.sin(index * 1.7) * 8;
		const angleInRadians = (angle * Math.PI) / 180;
		const speed = 15 + random() * 15;
		const peakDistance = 190 + speed * 8 + random() * 140;
		const horizontalNoise = (random() - 0.5) * 78;
		const startRadius = random() * HIGH_SCORE_CONFETTI_START_RADIUS;
		const startAngle = random() * Math.PI * 2;
		const startX = Math.cos(startAngle) * startRadius;
		const startY = Math.sin(startAngle) * startRadius * 0.35;
		const peakX = Math.cos(angleInRadians) * peakDistance + horizontalNoise;
		const peakY = Math.sin(angleInRadians) * peakDistance;
		const endX = peakX + (random() - 0.5) * (260 + speed * 6);
		const endY = 180 + random() * 320;

		return {
			color: HIGH_SCORE_CONFETTI_COLORS[index % HIGH_SCORE_CONFETTI_COLORS.length],
			duration: 3000 + Math.round(random() * 1000),
			endX: Math.round(endX),
			endY: Math.round(endY),
			peakX: Math.round(peakX),
			peakY: Math.round(peakY),
			rotation: Math.round((random() - 0.5) * 720),
			size: Math.round(4 + random() * 6),
			startX: Math.round(startX),
			startY: Math.round(startY),
			stretch: 0.8 + random() * 1.1,
		};
	});
};

export const HIGH_SCORE_CONFETTI_PIECES = createHighScoreConfettiPieces();
